import AppWrapper from "@jumbo/components/AppWrapper";
import React, {lazy} from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {App} from "@codeArt/apps";
import {requestUrl} from "@codeArt/utils/url";
import {RequestConfig} from "@codeArt/request";
import {main} from "project/constant/host";
import {useDispatch} from "react-redux";

const Extra = ({match}) => {
  const dispatch = useDispatch();
  const matchUrl = requestUrl(match);

  const layout = {
    sidebar: {hidden: true},
    footer: {hidden: true}
  };

  const routes = [
    {
      path: `${matchUrl}/login`,
      component: lazy(() => import("./routes/login")),
      default: true
    },
    {
      path: `${matchUrl}/init`,
      component: lazy(() => import("./routes/init"))
    }
  ];

  const init = success => {
    success();
  };

  return (
    <App
      init={success => {
        init(success);
      }}
      auth={false} //无须授权
      request={{domain: main}}
      getLayout={() => layout}
      routes={routes}
      dispatch={dispatch}
    />
  );
};

export default Extra;
